import { render, staticRenderFns } from "./ListSimple.vue?vue&type=template&id=728b6919&"
import script from "./ListSimple.vue?vue&type=script&lang=js&"
export * from "./ListSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports